export default {
  studentEnroll: {
    id: '',
    enrollNo: '',
    academicPeriodId: '',
    periodCode: '',
    studentId: '',
    studentCode: '',
    enrollDate: '',
    totalCredit: null,
    totalDropCredit: null,
    studentEnrollDetails: [],
    source: '',
  },
  studentEnrolls: [],
  processing: false,
  error: null,
  success: null,
}



